import styled from 'styled-components';

export const StyledForm = styled.form`
  padding: 0 16px;
  max-width: 800px;
`;
